import React,{ useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../login/AuthProvider";
import axios from "axios";
import { backend } from '../../../components/apipath';
const Form = (props) => {
    const { setAuth } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        const accountElement = document.getElementById('account');
        const passwordElement = document.getElementById('password');
    
        if (!accountElement || !passwordElement) {
            document.getElementById("error").innerText = "登入錯誤";
            return;
        }
    
        const account = accountElement.value;
        const password = passwordElement.value;
    
        try {
            const response = await axios.post(`${backend}login/employee`, {
                account,
                password
            });
    
            if (response.status === 200) {
                localStorage.setItem('authAdm', JSON.stringify(response.data));
                setAuth({
                    ...response.data,
                    authorized: true,
                });
                navigate("/adm/admh");
            } else {
                document.getElementById("error").innerText = "帳號密碼錯誤";
            }
        } catch (err) {
            document.getElementById("error").innerText = err.response.data.errors || err.message;
        }
    };
    return (
        <form id="form" onSubmit={handleSubmit}>
            <h2 className='mb-5'>Direct Line 後台登入</h2>
            <div>
                <label for="account">帳號</label>
                <input className='form-control' type="email" id="account" name="account" required />
            </div>
            <div>
                <label className=' mt-5' for="password">密碼</label>
                <input className='form-control' type="password" id="password" name="password" required />
            </div>
            <div id="error" ></div>
            <input className='btn btn-primary mt-5' type="submit" value="登入" />
        </form>
    )
}

export default Form;